// extracted by mini-css-extract-plugin
module.exports = {"container":"pZtJjmHg","checkList":"_1u7AwCkI","list":"N6VLKVue","item":"UDhXJTYd","icon":"_3Cm0XVKX","button":"_35HsXuPD","headingText":"_2x66oqw-"};